import { chartTableFlatTransformer } from '../chartTableFlatTransformer';
import { getPercentage, getDynamicPercentage } from './tableUtils';

const singleJobTableWithTotal = ({ data = [] }) => {
  const initialTotal = Array(15).fill(0);

  const dynamic_total = data?.reduce((acc, curr) => {
    for (let i = 0; i < initialTotal?.length; i++) {
      acc[i] = acc[i] + curr[`s${i + 1}_total_count`];
    }
    return acc;
  }, initialTotal);

  function innerFunc(data) {
    if (!data?.length) return [];
    return data.map((datum) => {
      const percentage = getDynamicPercentage(datum, dynamic_total);
      return {
        ...datum,
        dynamic_total,
        ...percentage,
        subRows: innerFunc(datum?.subRows),
      };
    });
  }

  return innerFunc(data);
};

const tableWithTotal = ({ data = [], misc }) => {
  if (misc) {
    return singleJobTableWithTotal({ data });
  }

  const application_review_total_count_total = data?.reduce(
    (acc, curr) => acc + curr?.application_review_total_count,
    0
  );
  const interviews_total_count_total = data?.reduce(
    (acc, curr) => acc + curr?.interviews_total_count,
    0
  );
  const offer_total_count_total = data?.reduce(
    (acc, curr) => acc + curr?.offer_total_count,
    0
  );
  const hired_total_count_total = data?.reduce(
    (acc, curr) => acc + curr?.hired_total_count,
    0
  );

  function innerFunc(data) {
    if (!data?.length) return [];
    return data.map((datum) => {
      return {
        ...datum,

        application_review_total_count_total,
        application_review_total_count_per: getPercentage(
          datum?.application_review_total_count,
          application_review_total_count_total
        ),

        interviews_total_count_total,
        interviews_total_count_total_per: getPercentage(
          datum?.interviews_total_count,
          interviews_total_count_total
        ),
        offer_total_count_total,
        offer_total_count_per: getPercentage(
          datum?.offer_total_count,
          offer_total_count_total
        ),
        hired_total_count_total,
        hired_total_count_per: getPercentage(
          datum?.hired_total_count,
          hired_total_count_total
        ),

        subRows: innerFunc(datum?.subRows),
      };
    });
  }

  return innerFunc(data);
};

export const pipelineTableTransformer = ({ response, args }) => {
  // Safely extract properties from response
  const { chart = [], headers, lookups, misc, table = [] } = response || {};
  const { dt, g1, g2 } = lookups || {}; // Lookup mappings for data transformation

  const data = g1?.length || g2?.length ? table : chart;
  const headerKey = g1?.length ? 'g1' : 'dt';

  const { group_by_1, group_by_2 } = args || {};

  // Transform raw chart data into a flat structure
  const transformedData = chartTableFlatTransformer({
    headerKey,
    headers,
    data,
    g1,
    g2,
    dt,
    g1Key: group_by_1?.id || group_by_1,
    g2Key: group_by_2?.id || group_by_2,
  });

  const tableData = tableWithTotal({ data: transformedData, misc });

  return tableData;
};
